<template>
  <v-autocomplete
    v-model="filter.municipioSecretariaId"
    :items="secretarias"
    clearable
    :label="'Secretarias'"
    item-text="nomeSecretaria"
    item-value="municipioSecretariaId"
    :multiple="multiple"
    v-on:change="$emit('onChange', valores)"
    :disabled="disabled"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
      v-if="multiple"
    >
      <div style="margin-right: 32px">
        <v-icon
          :color="
            filter.municipioSecretariaId.length > 0 ? 'indigo darken-4' : ''
          "
          >{{ iconMultiple }}</v-icon
        >
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" v-if="multiple" />

    <template v-slot:selection="{ item, index }">
      <div v-if="index < maxDisplay || !multiple">
        <span>{{ item.nomeSecretaria }}</span>
      </div>
      <span v-if="index === maxDisplay && multiple" class="grey--text caption"
        >(+{{
          filter.municipioSecretariaId.length - maxDisplay
        }}
        secretaria)</span
      >
    </template>
    <template slot="no-data"> Nenhuma secretaria retornada </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { citySecretariaAPI } from "@/modules/city/API/CitySecretariaAPI";

export default {
  name: "AppCitySolutionCombobox",
  props: ["filter", "itens", "disabled", "multiple", "municipioId"],
  data() {
    return {
      maxDisplay: 2,
      valores: [],
      secretarias: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
    likesAll() {
      return this.filter.municipioSecretariaId.length === this.itens.length;
    },
    likesSome() {
      return this.filter.municipioSecretariaId.length > 0 && !this.itens;
    },
    iconMultiple() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      citySecretariaAPI
        .findByMunicipio(this.municipioId)
        .then(({ data }) => {
          this.secretarias = data;
        })
        .catch((err) => {
          console.log("ERROR ComboboxSecretaria --> ", err);
          this.$notification.error("Erro ao obter secretarias");
        });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.municipioSecretariaId = [];
          this.$emit("onChange", this.valores);
        } else {
          this.filter.municipioSecretariaId = this.itens.slice();
          this.$emit("onChange", this.valores);
        }
      });
    },
  },
};
</script>
